// D12 — how the "Edit campaign" action-menu item must close the Radix
// DropdownMenu when it opens ScheduledCampaignEditModal.
//
// THE BUG THIS EXISTS TO FIX
// --------------------------
// The ModalOverlay work (modal-overlay.tsx) fixed the menu ⇄ edit-modal STACKING
// and the react-remove-scroll POINTER-EVENTS freeze, but left one path open: the
// Edit item used `e.preventDefault()` to keep the Radix menu MOUNTED (so the
// modal it opens as a sibling would not be torn down). With the menu still open
// behind the modal, its DismissableLayer treats the first in-modal click as an
// interact-OUTSIDE and dismisses — tearing the modal down before the click even
// completes (the modal is unusable: it closes on the first tab click / keystroke).
//
// The fix is to CLOSE the menu when Edit opens the modal. But HOW depends on the
// caller, because the modal's lifecycle is (today) coupled to this menu's mount:
//
//   - CONTROLLED callers (calendar-view, calendar-sidebar-campaign-row) pass
//     `onMenuClose`, wired to their own `open` setter. On the calendar the
//     Radix-initiated close path (onOpenChange → handleCloseMenu) NULLS the
//     `selectedCampaignId`/`menuPosition` this menu is mounted on, which unmounts
//     CampaignRowMenu — and the sibling modal — with it. So we must PREVENT
//     Radix's own close and instead close through the controlled setter, which
//     does NOT fire onOpenChange (a parent-driven prop change), leaving the
//     gating state intact so the modal survives.
//   - UNCONTROLLED callers (campaign-actions-menu, the bulk dashboard) have no
//     setter and do not null any gating state; letting Radix close the menu
//     normally is correct there and keeps CampaignRowMenu mounted, so the sibling
//     modal survives.
//
// Either way the invariant is the same: the menu must NOT be left open behind the
// modal. planEditMenuSelect encodes that per caller so a future edit cannot
// silently re-introduce the blanket `preventDefault()` that caused D12.

export interface EditMenuSelectPlan {
  /**
   * Prevent Radix's built-in "close the menu on select" so a controlled caller's
   * onOpenChange (which, on the calendar, unmounts this component) does not fire.
   * When true, the menu is instead closed via the controlled setter.
   */
  preventDefaultClose: boolean;
  /**
   * Drive the menu closed through the caller's `onMenuClose` setter — releasing
   * the Radix DismissableLayer + react-remove-scroll body lock that would
   * otherwise dismiss the just-opened edit modal on the first click.
   */
  callOnMenuClose: boolean;
}

/**
 * Decide how the "Edit campaign" item closes the action menu when it opens the
 * edit modal. `hasOnMenuClose` = the caller passed a controlled-close callback.
 */
export function planEditMenuSelect(hasOnMenuClose: boolean): EditMenuSelectPlan {
  return hasOnMenuClose
    ? { preventDefaultClose: true, callOnMenuClose: true }
    : { preventDefaultClose: false, callOnMenuClose: false };
}

/**
 * The D12 invariant: whichever plan we pick, the action menu is closed one way or
 * the other — never left open behind the modal (which is what let its
 * DismissableLayer dismiss the modal on the first click).
 */
export function planClosesMenu(plan: EditMenuSelectPlan): boolean {
  // Controlled: we manually close via the setter. Uncontrolled: we allow Radix's
  // own close (preventDefaultClose === false).
  return plan.callOnMenuClose || !plan.preventDefaultClose;
}
